export const createCommunityFieldsConfig = [
  {
    valuesKey: 'customerNumber',
    label: 'Customer Number',
    type: 'text',
    required: values => true,
    error: (touched, errors) => touched.customerNumber && errors.customerNumber,
  },
  {
    valuesKey: 'supplierId',
    label: 'Supplier ID',
    type: 'text',
    required: values => true,
    error: (touched, errors) => touched.supplierId && errors.supplierId,
  },
  {
    valuesKey: 'communityId',
    label: 'Community ID',
    type: 'text',
    required: values => true,
    error: (touched, errors) => touched.communityId && errors.communityId,
  },
  {
    valuesKey: 'communityName',
    label: 'Community Name',
    type: 'text',
    required: values => true,
    error: (touched, errors) => touched.communityName && errors.communityName,
  },
  {
    valuesKey: 'invoiceLevel',
    label: 'Invoicing level',
    type: 'select',
    disabled: values => !values.features?.includes(SHARED_USERS),
    options: [
      {
        label: 'Workspace',
        value: 'Workspace',
        disabled: values => !values.features?.includes(SHARED_USERS),
      },
      {
        label: 'Community',
        value: 'Community',
        disabled: values => !values.features?.includes(SHARED_USERS),
      },
    ],
    required: values => true,
    error: (touched, errors) => touched.invoiceLevel && errors.invoiceLevel,
  },
  {
    valuesKey: 'agreementId',
    label: 'Agreement ID',
    type: 'text',
    required: values => true,
    error: (touched, errors) => touched.agreementId && errors.agreementId,
  },
  {
    valuesKey: 'project',
    label: 'Project',
    type: 'text',
    required: values => false,
    error: (touched, errors) => touched.project && errors.project,
  },
  {
    valuesKey: 'salesContactName',
    label: 'Sales contact name',
    type: 'text',
    required: values => false,
    error: (touched, errors) =>
      touched.salesContactName && errors.salesContactName,
  },
  {
    valuesKey: 'salesContactEmail',
    label: 'Sales contact email',
    type: 'text',
    required: values => false,
    error: (touched, errors) =>
      touched.salesContactEmail && errors.salesContactEmail,
  },
  {
    valuesKey: 'customerContactName',
    label: 'Customer contact name',
    type: 'text',
    required: values => false,
    error: (touched, errors) =>
      touched.customerContactName && errors.customerContactName,
  },
  {
    valuesKey: 'customerContactEmail',
    label: 'Customer contact email',
    type: 'text',
    required: values => false,
    error: (touched, errors) =>
      touched.customerContactEmail && errors.customerContactEmail,
  },
  {
    valuesKey: 'password',
    label: 'Community Admin Password',
    type: 'text',
    required: values => !values.communityId,
    error: (touched, errors) => touched.password && errors.password,
  },
  {
    valuesKey: 'confirmPassword',
    label: 'Repeat Password',
    type: 'text',
    required: values => !values.communityId,
    error: (touched, errors) =>
      touched.confirmPassword && errors.confirmPassword,
  },
  {
    valuesKey: 'secret',
    label: 'Community Secret',
    type: 'text',
    required: values => !values.secret,
    error: (touched, errors) => touched.secret && errors.secret,
  },
  {
    valuesKey: 'confirmSecret',
    label: 'Repeat Secret',
    type: 'text',
    error: (touched, errors) => touched.confirmSecret && errors.confirmSecret,
  },
  {
    valuesKey: 'tenantStore',
    type: 'select',
    custom: true,
    label: 'Community storage',
    error: (touched, errors) => touched.tenantStore && errors.tenantStore,
  },
];

export const updateCommunityFieldsConfig = [
  {
    valuesKey: 'customerNumber',
    label: 'Customer Number',
    type: 'text',
    required: values => true,
    error: (touched, errors) => touched.customerNumber && errors.customerNumber,
  },
  {
    valuesKey: 'supplierId',
    label: 'Supplier ID',
    type: 'text',
    required: values => true,
    error: (touched, errors) => touched.supplierId && errors.supplierId,
  },
  {
    valuesKey: 'communityId',
    label: 'Community ID',
    type: 'text',
    required: values => true,
    error: (touched, errors) => touched.communityId && errors.communityId,
    disabled: () => true,
  },
  {
    valuesKey: 'communityName',
    label: 'Community Name',
    type: 'text',
    required: values => true,
    error: (touched, errors) => touched.communityName && errors.communityName,
  },
  {
    valuesKey: 'invoiceLevel',
    label: 'Invoicing level',
    type: 'select',
    disabled: values => !values.features?.includes(SHARED_USERS),
    options: [
      {
        label: 'Workspace',
        value: 'Workspace',
        disabled: values => !values.features?.includes(SHARED_USERS),
      },
      {
        label: 'Community',
        value: 'Community',
        disabled: values => !values.features?.includes(SHARED_USERS),
      },
    ],
    required: values => true,
    error: (touched, errors) => touched.invoiceLevel && errors.invoiceLevel,
  },
  {
    valuesKey: 'agreementId',
    label: 'Agreement ID',
    type: 'text',
    required: values => values.invoiceLevel === 'Community',
    error: (touched, errors) => touched.agreementId && errors.agreementId,
  },
  {
    valuesKey: 'project',
    label: 'Project',
    type: 'text',
    required: values => false,
    error: (touched, errors) => touched.project && errors.project,
  },
  {
    valuesKey: 'salesContactName',
    label: 'Sales contact name',
    type: 'text',
    required: values => false,
    error: (touched, errors) =>
      touched.salesContactName && errors.salesContactName,
  },
  {
    valuesKey: 'salesContactEmail',
    label: 'Sales contact email',
    type: 'text',
    required: values => false,
    error: (touched, errors) =>
      touched.salesContactEmail && errors.salesContactEmail,
  },
  {
    valuesKey: 'customerContactName',
    label: 'Customer contact name',
    type: 'text',
    required: values => false,
    error: (touched, errors) =>
      touched.customerContactName && errors.customerContactName,
  },
  {
    valuesKey: 'customerContactEmail',
    label: 'Customer contact email',
    type: 'text',
    required: values => false,
    error: (touched, errors) =>
      touched.customerContactEmail && errors.customerContactEmail,
  },
];

export const GENERATOR = 'generator';
export const DRAWING_MANAGEMENT = 'drawingManagement';
export const WORKSPACES = 'workspaces';
export const SHARED_USERS = 'sharedUsers';
export const VISUAL_BOARDS = 'visualBoards';
export const PUBLIC_LINKS = 'publicLinks';
export const ACTION_LOG = 'actionLog';
export const DISTRIBUTION_GROUPS = 'communityGroup';
export const MFA = 'mfaRequired';
export const INTERNAL_COMMENTS = 'internalComments';
export const CREATE_ROOM = 'createRoom';
export const EXTERNAL_PUBLISH = 'externalPublish';
export const ORDER_ROOM = 'orderRoom';
export const PROJECT_INSIGHTS = 'projectInsights';
export const OCULO_INTEGRATION = 'oculoIntegration';
export const PROJECT_CAPTURE = 'projectCapture';
export const NVDB_INTEGRATION = 'nvdbIntegration';
export const IX_INTELLIGENCE = 'ixIntelligence';

export const communityFeaturesFieldsConfig = [
  {
    label: 'Allow room creation',
    key: CREATE_ROOM,
    valuesKey: 'createRoomEnabled',
    tooltip: '',
  },
  {
    label: 'Allow room order',
    key: ORDER_ROOM,
    valuesKey: 'orderRoomEnabled',
    tooltip: '',
  },
  {
    label: 'Automatic entry ID',
    key: GENERATOR,
    valuesKey: 'generatorEnabled',
    tooltip: '',
  },
  {
    label: 'Capture',
    key: PROJECT_CAPTURE,
    valuesKey: 'projectCaptureEnabled',
    tooltip: '',
  },
  {
    label: 'Distribution groups',
    key: DISTRIBUTION_GROUPS,
    valuesKey: 'communityGroupEnabled',
    tooltip: '',
  },
  {
    label: 'Drawing management',
    key: DRAWING_MANAGEMENT,
    valuesKey: 'drawingManagementEnabled',
    tooltip: '',
  },
  {
    label: 'Internal comments',
    key: INTERNAL_COMMENTS,
    valuesKey: 'internalCommentsEnabled',
    tooltip: '',
  },
  {
    label: 'Insights',
    key: PROJECT_INSIGHTS,
    valuesKey: 'projectInsightsEnabled',
    tooltip: '',
  },
  {
    label: 'AI-assistant: Interaxo Intelligence',
    key: IX_INTELLIGENCE,
    valuesKey: 'ixIntelligenceEnabled',
    tooltip: '',
  },
  {
    label: 'Multifactor authentication',
    key: MFA,
    valuesKey: 'mfaRequired',
    tooltip: '',
  },
  {
    label: 'NVDB integration',
    key: NVDB_INTEGRATION,
    valuesKey: 'nvdbIntegrationEnabled',
    tooltip: '',
  },
  {
    label: 'Oculo Integration',
    key: OCULO_INTEGRATION,
    valuesKey: 'oculoIntegrationEnabled',
    tooltip: '',
  },
  {
    label: 'Public links',
    key: PUBLIC_LINKS,
    valuesKey: 'publicLinksEnabled',
    tooltip: '',
  },
  {
    label: 'Publish to separate folder',
    key: EXTERNAL_PUBLISH,
    valuesKey: 'externalPublishEnabled',
    tooltip: '',
  },
  {
    label: 'Shared users',
    key: SHARED_USERS,
    valuesKey: 'sharedUsersEnabled',
    tooltip: '',
  },
  {
    label: 'Visual boards',
    key: VISUAL_BOARDS,
    valuesKey: 'visualBoardsEnabled',
    tooltip: '',
  },
  {
    label: 'Workspaces',
    key: WORKSPACES,
    valuesKey: 'workspacesEnabled',
    tooltip: '',
  },
];

export const oldNewFeatureMapping = communityFeaturesFieldsConfig.reduce(
  (acc, feature) => {
    acc[feature.valuesKey] = feature.key;
    return acc;
  },
  {},
);
